export default __webpack_public_path__ + "static/Air_Conditioner-fb4a0b36f0c0cd1b1baaafc7c1a9eee0.png";